'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  transform: ', ';\n  opacity: ', ';\n  visibility: ', ';\n  transform-origin: 0% 100%;\n  position: relative;\n  z-index: ', ';\n\n  ', ';\n'], ['\n  transform: ', ';\n  opacity: ', ';\n  visibility: ', ';\n  transform-origin: 0% 100%;\n  position: relative;\n  z-index: ', ';\n\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var RocketPack = _styledComponents2.default.div(_templateObject, function (_ref) {
  var pack = _ref.pack,
      _ref$transition = _ref.transition,
      x = _ref$transition.x,
      y = _ref$transition.y;
  return pack ? 'translate(' + x + 'px, ' + y + 'px) scale(0.1)' : 'none';
}, function (_ref2) {
  var pack = _ref2.pack;
  return pack ? 0 : 1;
}, function (_ref3) {
  var pack = _ref3.pack;
  return pack ? 'hidden' : 'visible';
}, function (_ref4) {
  var pack = _ref4.pack;
  return pack ? 1000000010 : 'initial';
}, (0, _polished.transitions)('transform .45s ease-in, opacity .45s ease-in, visibility .45s ease-in'));

exports.default = RocketPack;